import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const GlobalAdmin = lazy(() =>
  import('./admin').then(m => ({default: m.GlobalAdmin})),
)

const InnerBlock = lazy(() =>
  import('./FooterBlock').then(m => ({default: m.FooterBlock})),
)

export const footerBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  GlobalAdmin,
  InnerBlock,
  dividers: false, // FooterRow supplies its own
})
